import { action } from 'typesafe-actions'
import { MostActiveCpt4Types } from './types'

export const getMostActiveCpt4Request = () =>
    action(MostActiveCpt4Types.FETCH_MOST_ACTIVE_CPT4_REQUEST)

export const getMostActiveCpt4Success = (data: any) =>
    action(MostActiveCpt4Types.FETCH_MOST_ACTIVE_CPT4_SUCCESS, data)

export const getMostActiveCpt4Fail = (message: string) =>
    action(MostActiveCpt4Types.FETCH_MOST_ACTIVE_CPT4_FAIL, message)

export const createMostActiveCpt4Request = () =>
    action(MostActiveCpt4Types.CREATE_MOST_ACTIVE_CPT4_REQUEST)

export const createMostActiveCpt4Success = (data: any) =>
    action(MostActiveCpt4Types.CREATE_MOST_ACTIVE_CPT4_SUCCESS, data)

export const createMostActiveCpt4Fail = (message: string) =>
    action(MostActiveCpt4Types.CREATE_MOST_ACTIVE_CPT4_FAIL, message)

export const updateMostActiveCpt4Request = () =>
    action(MostActiveCpt4Types.UPDATE_MOST_ACTIVE_CPT4_REQUEST)

export const updateMostActiveCpt4Success = (data: any) =>
    action(MostActiveCpt4Types.UPDATE_MOST_ACTIVE_CPT4_SUCCESS, data)

export const updateMostActiveCpt4Fail = (message: string) =>
    action(MostActiveCpt4Types.UPDATE_MOST_ACTIVE_CPT4_FAIL, message)

export const deleteMostActiveCpt4Request = () =>
    action(MostActiveCpt4Types.DELETE_MOST_ACTIVE_CPT4_REQUEST)

export const deleteMostActiveCpt4Success = (data: any) =>
    action(MostActiveCpt4Types.DELETE_MOST_ACTIVE_CPT4_SUCCESS, data)

export const deleteMostActiveCpt4Fail = (message: string) =>
    action(MostActiveCpt4Types.DELETE_MOST_ACTIVE_CPT4_FAIL, message)